import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const BagIcon = createIcon({
    viewBox: '0 0 20 20',
    path: (
        <Path
            fillRule='evenodd'
            fill='currentColor'
            d='M7.046 3.353h5.908c.408 0 .74.33.74.738v3.693h2.084c.48 0 .87.39.87.87v7.124c0 .48-.39.87-.87.87H4.222a.87.87 0 0 1-.87-.87V8.654c0-.48.39-.87.87-.87h2.085V4.091c0-.408.33-.738.739-.738zm.738 1.477v2.954h4.432V4.83H7.784z'
        />
    ),
})

BagIcon.displayName = 'BagIcon'
